import { Card } from '@/components/ui/card';
import type { LucideIcon } from 'lucide-react';

interface WasteCounterCardProps {
  icon: LucideIcon;
  label: string;
  sublabel?: string;
  value: number;
  decimals?: number;
  prefix?: string;
  color: 'red' | 'orange' | 'yellow';
}

const colorMap = {
  red: {
    text: 'text-red-500',
    shadow: 'shadow-red-500/20',
    border: 'border-red-500/30',
    bg: 'from-red-500/5 to-transparent',
    icon: 'text-red-400',
  },
  orange: {
    text: 'text-orange-500',
    shadow: 'shadow-orange-500/20',
    border: 'border-orange-500/30',
    bg: 'from-orange-500/5 to-transparent',
    icon: 'text-orange-400',
  },
  yellow: {
    text: 'text-yellow-500',
    shadow: 'shadow-yellow-500/20',
    border: 'border-yellow-500/30',
    bg: 'from-yellow-500/5 to-transparent',
    icon: 'text-yellow-400',
  },
};

export function WasteCounterCard({
  icon: Icon,
  label,
  sublabel,
  value,
  decimals = 0,
  prefix = '',
  color,
}: WasteCounterCardProps) {
  const c = colorMap[color];

  const formatted =
    prefix +
    value.toLocaleString('es-CL', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });

  return (
    <Card
      className={`
        relative overflow-hidden border ${c.border}
        shadow-lg ${c.shadow}
        bg-gradient-to-br ${c.bg}
        transition-shadow duration-300
        hover:shadow-xl
      `}
    >
      <div className="p-6 flex flex-col items-center gap-3">
        <Icon className={`w-8 h-8 ${c.icon}`} />
        <span className={`text-3xl sm:text-4xl font-bold tabular-nums font-mono ${c.text}`}>
          {formatted}
        </span>
        <span className="text-sm text-muted-foreground font-medium text-center">{label}</span>
        {sublabel && (
          <span className="text-[10px] text-muted-foreground/60 text-center leading-tight">
            {sublabel}
          </span>
        )}
      </div>
    </Card>
  );
}
